import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { MenuController,AlertController } from '@ionic/angular';
import { GarmentReportService } from '../../../garment-listing/services/garment-report.service';
import { ToasterService } from '../../../../common/services/toaster.service';
import { GarmentRepairService } from '../../../g-route/services/garment-repair.service';
import { NavController } from '@ionic/angular';
import { environment } from '../../../../../environments/environment';
@Component({
  selector: 'app-garment-detail',
  templateUrl: './garment-detail.page.html',
   styleUrls: [
    './garment-detail.page.scss'
  ]
})
export class GarmentDetailComponent implements OnInit, OnDestroy {
  garmentCode:string;
  loaded:boolean=false;
  breadcrumbs=[];
  messageCode: string;
  selectedReasons: string[] = [];
  selectedmessageCode: string[] = [];
  routeStopName: string = "";
  messageText: string = '';
  garment:any;
  isSavedSuccessfully = false;
  captchaToken: string | null = null;
  captchaError: string = '';
  widgetId: any;
  isCorrect:boolean=false;
  constructor(
    public menu: MenuController,
    private garmentReportService: GarmentReportService,
    private toasterService: ToasterService,
    private route: ActivatedRoute,
    private navController: NavController,
     private alertController: AlertController,
    private garmentRepairService: GarmentRepairService,
  ) { 
   var grecaptcha: any;
  }
  async ngOnInit(): Promise<void> {
    
    this.loaded=false;
    this.garmentCode = this.route.snapshot.paramMap.get('garmentCode');
    await this.getGarmentDetail();
    this.loaded=true;
      
  }
renderCaptcha() {

 setTimeout(() => {
    if (typeof grecaptcha !== 'undefined') {
      this.widgetId = grecaptcha.render('captcha-container', {
        sitekey: environment.siteKey,

        callback: (response: string) => {
          this.captchaToken = response;
          this.captchaError = ''; 
        },

       'expired-callback': () => {
          this.captchaToken = null;
          grecaptcha.reset(this.widgetId);
          this.captchaError = 'Captcha expired. Please verify again.';
        },

        'error-callback': () => {
          this.captchaToken = null;
          this.captchaError = 'Captcha failed to load. Please refresh.';
        }
      });
    }
  }, 1000);
}
  ionViewWillEnter() {
    
  document.body.classList.add('hide-menu');
    this.menu.enable(false);
  }


goBack() {
   this.navController.back();
}
 
  ngOnDestroy(): void {
  }
  async getGarmentDetail(){
    this.loaded=false;
    
    if (this.garmentCode && this.garmentCode.length > 0) {
      var response = await this.garmentReportService.findForGarmentDetails( this.garmentCode );
       this.garment =response?.data;
      if (response.success) {
        this.renderCaptcha();
        }
        this.loaded=true;
    }
    else{
      
      this.garment=null;
      this.toasterService.presentToast('primary', '', 'Please Enter Garment Code ', 2000);
    }
    this.loaded=true;
  }
   onReasonChange() {
        const selectedOption = this.getReasonText(this.messageCode);
        if (selectedOption) {
          this.messageText = selectedOption;
        }
        this.addToMultiselectList();

      }
    addToMultiselectList() {
        if (this.messageText && !this.selectedReasons.includes(this.messageText)) {
            this.selectedReasons.push(this.messageText);
            this.selectedmessageCode.push(this.messageCode);
          }
           setTimeout(() => {
    this.messageCode = undefined;
  }, 0);
      }
      removeReason(index: number) {
        this.selectedReasons.splice(index, 1); 
        this.selectedmessageCode.splice(index, 1);
      }
      getReasonText(value: string): string {
        const reasonMap: { [key: string]: string } = {
          '06': 'Relable Garment ID',
          '15': 'Repair - Belt Loop / Drawstring',
          '11': 'Repair - Buttons, Button Holes, Snaps',
          '13': 'Repair - Check All',
          'MSG0010064': 'Repair - Check Seat / Inner Thigh',
          'MSG0010031': 'Repair - Check Zipper',
          '21': 'Repair - Emblems',
          '14': 'Repair - Pockets',
          '12': 'Repair - Seams or Hems',
          'MSG0010070': 'Repair - Sleeve/Cuff',
          'MSG0010042': 'Repair - Tear',
          'MSG0010080': 'Replace - Inspect for Replacement',
          '05': 'Send to Customer Service',
          'MSG0010033': 'Verify - All Emblems',
          'MSG0010046': 'Verify - Name Emblem Spelling'
        };
        return reasonMap[value];
      }
    async PostMessage(){
        this.loaded=false;
        if ((this.garmentCode !== undefined && this.garmentCode !== "" && this.garmentCode !== null) && (this.selectedmessageCode !== undefined && this.selectedmessageCode.length!= 0 && this.selectedmessageCode !== null)) {  
          if (!this.captchaToken) {
                this.toasterService.presentToast(
                  'danger',
                  '',
                  'Please complete the CAPTCHA to verify that you are not a robot.',
                  5000
                );
                 this.loaded=true;
                return;
              }
            else{
               await this.garmentRepairService.saveRepairMessage(this.selectedmessageCode, this.garmentCode,this.captchaToken).then((response)=> {
                 if (response=="success") {
                    this.loaded=true;
                    this.isSavedSuccessfully = true; 
                    this.messageCode = null;
                    this.garmentCode = null;
                    this.selectedmessageCode=[];
                    this.messageText=null;
                    grecaptcha.reset(this.widgetId);
                   this.captchaToken = null;
                }
                 else {
                    this.loaded=true;
                    this.toasterService.presentToast('danger', '', 'Something went wrong. Please try again.', 5000);
                }
            });
          }
        }
        else{
            this.loaded=true;
            this.toasterService.presentToast('danger', '', 'Please Select Repair Reason', 5000);
        }
        this.loaded=true;
    }
  showRepairList(){
    this.isSavedSuccessfully=false;
    this.isCorrect=true;
  }
  async navigateOnScanPage(){
    const alert = await this.alertController.create({
      header: 'Try Again',
      message: 'Please re-enter the garment code.<br> <div style="text-align:center; font-weight:600;"> OR </div>Re-scan the barcode.',
      backdropDismiss: false, 
       cssClass: 'custom-alert-width',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.navController.back();
          }
        }
      ]
  });
  await alert.present();
  }

}
